export default "__VITE_ASSET__DBv2hXnO__"